export const SET_SCHEDULED_BUNDLES = 'SET_SCHEDULED_BUNDLES'
export const RESET_SCHEDULED_BUNDLES = 'RESET_SCHEDULED_BUNDLES'